import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation, useNavigate } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { Col, Row, Table } from "reactstrap";
import { avantSolarApi } from "api/authApi";
import { useSelector } from "react-redux";
import DataTableProdPeriodo from "components/datatable/datatableProdPeriodo";
import Alert from "components/alert";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";

var ps;

function ProduccionPeriodo(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [datos, setDatos] = useState([]);
  const [datosCopy, setDatosCopy] = useState([]);
  const navigate = useNavigate();
  const { user, jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [consulta, setConsulta] = useState(null);

  useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  useEffect(() => {
    if (consulta) {
      fetchDatos(consulta);
    }
  }, [huerta]);

  const fetchDatos = async (consulta) => {
    console.log("Aqui");
    setError(null);
    setLoading(true);

    try {
      const response = await avantSolarApi.get(
        `/admins/productionMeter?id_huerta=${huerta}` + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      console.log(data);
      setLoading(false);
      if (data?.code == 200) {
        setDatos([...data.data]);
        setDatosCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let diaFechaIni = event.target.fechaIni.value.substring(8, 10);
    let mesFechaIni = event.target.fechaIni.value.substring(5, 7);
    let anioFechaIni = event.target.fechaIni.value.substring(0, 4);
    let diaFechaFin = event.target.fechaFin.value.substring(8, 10);
    let mesFechaFin = event.target.fechaFin.value.substring(5, 7);
    let anioFechaFin = event.target.fechaFin.value.substring(0, 4);
    let tipo = event.target.tipo.value;
    let consulta = `&fecha_inicio=${anioFechaIni}${mesFechaIni}${diaFechaIni}&fecha_fin=${anioFechaFin}${mesFechaFin}${diaFechaFin}&tipo=${tipo}`;
    setConsulta(consulta);
    fetchDatos(consulta);
  };

  const headers = [[" ", " ", " ", " ", ""]];
  const headersTable = [
    { name: "Titular", prop: "titular" },
    { name: "Instalación", prop: "instalacion" },
    { name: `Potencia`, prop: "potencia" },
    { name: "Usuario", prop: "usuario" },
  ];

  const properties = ["titular", "instalacion", "potencia", "usuario"];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-1">
            <form
              className="w-100"
              onSubmit={(event) => handleSubmitForm(event)}
            >
              <Row className="w-100">
                <Col className="w-100 mt-3 mt-lg-0" xs={12} xl={6}>
                  <div className="d-flex justify-content-center justify-content-xl-end align-items-center w-100 h-100">
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <label className=" ml-2 d-flex align-items-center flex-column">
                        <p>Fecha Inicial:</p>{" "}
                        <input
                          required
                          name="fechaIni"
                          className="p-1"
                          type="date"
                        />
                      </label>
                      <label className=" ml-2 d-flex align-items-center flex-column">
                        <p>Fecha Final:</p>
                        <input
                          required
                          name="fechaFin"
                          className="p-1 ml-2"
                          type="date"
                        />
                      </label>
                    </div>
                  </div>
                </Col>
                <Col className="w-100 mt-3 mt-lg-0" xs={12} xl={6}>
                  <div className="d-flex justify-content-center justify-content-xl-start align-items-center w-100">
                    <div className="d-flex justify-content-center align-items-center ">
                      <select
                        className="custom-select"
                        defaultValue={"0"}
                        name="tipo"
                      >
                        <option value={"0"}>Inversores</option>
                        <option value={"1"}>Contadores</option>
                      </select>

                      <label>
                        <button className="btn btn-primary ml-2">Enviar</button>
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </form>

            {!error && (
              <DataTableProdPeriodo
                data={datos}
                dataCopy={datosCopy}
                setData={setDatosCopy}
                titleProps={
                  "Producción Periodo - Huerta: " +
                  obtenerNombreHuertaId(huerta)
                }
                headers={headers}
                headersTable={headersTable}
                name={"produccionPeriodo"}
                properties={properties}
                defaultMostrar={40}
                loading={loading}
              ></DataTableProdPeriodo>
            )}

            {error && <Alert message={error} />}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ProduccionPeriodo;
